
// import { useLoader } from "./apiLoader";
// import Backdrop from "@mui/material/Backdrop";
// import { Box } from "@mui/material";
// import CircularProgress from "@mui/material/CircularProgress";
// const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const GlobalLoader = () => {
  // const loader = useLoader();

  return (
    <>
      {/* {loader && <div className="loader">Loading...</div>} */}
        {/* <CircularProgress color="inherit" /> */}
      {/* <Backdrop open={loader} sx={{ color: "#fff", zIndex: 9999 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            transform: "scale(1.4)",
            zIndex: 9999,
            background: "",
            opacity: 0.8,
          }}
        ></Box>
      </Backdrop> */}
    </>
  );
};

export default GlobalLoader;
